// src/modules/purityAnalyzer/components/CalculationStepsPanel.jsx
// Step-by-step formula trace + Archimedes-principle explanation drawer content.

import React from 'react';
import { Steps, Typography, Card, theme } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

export function ArchimedesExplanation() {
  return (
    <Typography>
      <Paragraph>
        <Text strong>Archimedes' Principle:</Text> a body immersed in a fluid loses
        exactly as much weight as the fluid it displaces. Since the displaced volume
        equals the body's own volume, the weight lost in diesel reveals the sample's
        volume — and weight ÷ volume is density.
      </Paragraph>
      <Paragraph>
        <Text strong>1 · Copper calibration.</Text> A copper reference (known density)
        is weighed in air and in diesel. From its immersion loss the system derives the
        <Text code>diesel density</Text> — this also acts as a temperature index, because
        diesel gets lighter as it warms.
      </Paragraph>
      <Paragraph>
        <Text strong>2 · Gold density.</Text> The gold sample is weighed in air and in
        diesel. Using the calibrated diesel density:
        {' '}<Text code>ρ(gold) = ρ(diesel) × W(air) / (W(air) − W(diesel))</Text>.
      </Paragraph>
      <Paragraph>
        <Text strong>3 · Purity.</Text> Pure gold is far denser (~19.32 g/cm³) than the
        metals it is alloyed with, so density maps to purity. The system interpolates the
        measured density over the ACTIVE calibration dataset — a table of density→purity
        points verified against XRF — to predict the final purity percentage.
      </Paragraph>
    </Typography>
  );
}

export default function CalculationStepsPanel({ steps = [] }) {
  const { token } = theme.useToken();
  if (!steps.length) return null;
  return (
    <Card
      size="small"
      title={<span><ExperimentOutlined style={{ marginRight: 8 }} />Calculation Steps</span>}
    >
      <Steps
        direction="vertical"
        size="small"
        current={steps.length}
        items={steps.map((s) => ({
          title: <Text strong style={{ fontSize: 13 }}>{s.label}</Text>,
          description: (
            <div style={{ fontSize: 12 }}>
              {s.formula && (
                <div>
                  <Text code style={{ fontSize: 12 }}>{s.formula}</Text>
                </div>
              )}
              {s.substitution && (
                <Text type="secondary" style={{ fontSize: 12 }}>{s.substitution}</Text>
              )}
              {s.result && (
                <div style={{ color: token.colorPrimary, fontWeight: 600 }}>= {s.result}</div>
              )}
            </div>
          ),
        }))}
      />
    </Card>
  );
}
